
import Icon from '@/ui-kit/components/icon';
import Gutter from '@/ui-kit/components/gutter';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleSizeType, StyleColorSchemeType, StylePositionType } from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Half from '@/components/layout/half';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { Comparator } from '@/ui-kit/enums';
import Button from '@/ui-kit/components/button';
import { CalculationType, ImageSize } from '@/components/page-specific/commission-calculator/enums';
import routes from '@/constants/routes';

/**
 * @component FooterComponent
 *
 * @prop {String} title
 * @prop {String} description
 * @prop {Array} items
 * @prop {String} type
 * @private
 */

export default {
  name: 'FooterComponent',
  components: {
    Icon,
    Gutter,
    Typography,
    Half,
    LazyImage,
    Button,
  },
  mixins: [WindowSize],
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      text: {
        type: String,
      },
    },
    type: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: () => {},
    },
    buyerTitle: {
      type: String,
      default: '',
    },
    sellerTitle: {
      type: String,
      default: '',
    },
    bottomDescription: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      TypographyType,
      CalculationType,
      ImageSize,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    footerImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: this.breakpoints.Medium,
          imageSize: ImageSize.Large,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: this.breakpoints.Medium,
          imageSize: ImageSize.Small,
        },
      ];
    },
    buttonText() {
      return this.type === CalculationType.Buyer
        ? 'Browse Homes'
        : 'List Your Home';
    },
    titleText() {
      return this.type === CalculationType.Buyer
        ? this.buyerTitle
        : this.sellerTitle;
    },
    footerLinkRedirectTo() {
      return this.type === CalculationType.Buyer
        ? routes.search
        : routes.listHome;
    },
  },
  methods: {
    handleFooterButtonClick() {
      this.$router.push(this.footerLinkRedirectTo);
    },
  },
};
